import { useEffect, useState, useRef } from "react";
import "./styles.scss";

export default function PDFSidebar({ pdf, currentPage, onPageClick, loading }) {
    const [thumbnails, setThumbnails] = useState([]);
    const sidebarRef = useRef();

    useEffect(() => {
        if (!pdf) return;
        let cancelled = false;

        async function renderThumbnails() {
            for (let i = 1; i <= pdf.numPages; i++) {
                if (cancelled) return;
                try {
                    const page = await pdf.getPage(i);
                    const viewport = page.getViewport({ scale: 0.15 });
                    const canvas = document.createElement('canvas');
                    const context = canvas.getContext('2d');
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;

                    await page.render({ canvasContext: context, viewport }).promise;
                    const thumbUrl = canvas.toDataURL();

                    if (!cancelled) {
                        setThumbnails(prev => {
                            const newThumbs = [...prev];
                            newThumbs[i - 1] = { pageNum: i, url: thumbUrl };
                            return newThumbs;
                        });
                    }
                } catch (err) {
                    console.error("Error generating thumbnail for page", i, err);
                }
            }
        }

        setThumbnails([]); // Reset thumbnails when pdf changes
        renderThumbnails();
        return () => { cancelled = true; };
    }, [pdf]);

    useEffect(() => {
        const activeElem = sidebarRef.current?.querySelector(`.thumb-container.active`);
        if (activeElem && sidebarRef.current) {
            const container = sidebarRef.current;
            const containerRect = container.getBoundingClientRect();
            const targetRect = activeElem.getBoundingClientRect();

            if (targetRect.top < containerRect.top || targetRect.bottom > containerRect.bottom) {
                const relativeTop = targetRect.top - containerRect.top + container.scrollTop;
                container.scrollTo({
                    top: relativeTop - (container.clientHeight / 2) + (activeElem.clientHeight / 2),
                    behavior: 'smooth'
                });
            }
        }
    }, [currentPage]);

    const items = loading 
        ? Array.from({ length: 10 }, (_, i) => ({ pageNum: i + 1, loading: true }))
        : pdf 
            ? Array.from({ length: pdf.numPages }, (_, i) => thumbnails[i] || { pageNum: i + 1, loading: true }) 
            : [];

    return (
        <div className="pdf-sidebar" ref={sidebarRef}>
            {items.map((item) => (
                <div
                    key={item.pageNum}
                    className={`thumb-container ${currentPage === item.pageNum ? 'active' : ''} ${item.loading ? 'skeleton' : ''}`}
                    onClick={() => !item.loading && onPageClick(item.pageNum)}
                >
                    <div className="thumb-wrapper">
                        {!item.loading ? (
                            <img src={item.url} alt={`Page ${item.pageNum}`} />
                        ) : (
                            <div className="skeleton-placeholder" />
                        )}
                        <div className="page-badge">{item.pageNum}</div>
                    </div>
                </div>
            ))}
        </div>
    );
}
